// design system reference - https://www.figma.com/file/AoPBCxLeZRZzLnihN7MTXl/New-UU-Design-System

const purge = process.env.NODE_ENV === 'production' ? [
  './src/**/*.html',
  './src/**/*.js',
  './src/**/*.jsx',
] : [];

module.exports = {
  purge,
  darkMode: false, // or 'media' or 'class'
  theme: {
    extend: {
      boxShadow: {
        'radio-ring': '0px 0px 0px 2px #FFFFFF, 0px 0px 0px 4px #4467AB',
        'input-ring': '0px 1px 2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px #4467AB',
        'input-error-ring': '0px 1px 2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px #EF4444',
      },
      colors: {
        // blues
        'brand-blue': '#2C405A',
        'dark-blue': '#182A44',
        'action-blue': '#2874AF',
        'action-light-blue': '#52B4FF',
        'action-darker-blue': '#105890',
        'light-pale-blue': '#ECF5FD',
        'pale-blue': '#F1F6FA',
        'med-pale-blue': '#E3EBF3',
        'dark-pale-blue': '#C7D8E8',
        'gray-blue': '#808D9E',
        'current-blue': '#4467AB',
        'current-med-blue': '#5E91F7',
        // grays
        grey: '#525F73',
        'white-grey': '#FAFBFC',
        'light-grey': '#F6F6F6',
        'grey-500': '#6B7280',
        'border-grey': '#D1D5DB',
        // greens
        green: '#117E15',
        'light-green': '#1CCA21',
        'pale-green': '#E7F3E5',
        // reds
        red: '#CF2A2A',
        'light-red': '#FF9494',
        'validation-red': '#D0021B',
        // oranges
        orange: '#DA6625',
        // yellows
        yellow: '#F6C83B',
        'medium-yellow': '#F7C83B',
        // others
        purple: '#712F79',
        'light-purple': '#EAA1F2',
        white: '#FFFFFF',
        'table-border-color': '#b7d2e5cc',
      },
      fontFamily: {
        'regular-font': '"Proxima Nova", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        'medium-font': '"Proxima Nova Medium", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        'heavy-font': '"Proxima Nova Heavy", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
      },
      fontSize: {
        '13px': '13px',
        '15px': '15px',
      },
      height: {
        1.5: '0.375rem',
        9: '2.25rem',
        '38px': '38px',
        '700px': '700px',
      },
      minWidth: {
        '400px': '400px',
      },
      inset: {
        46: '46px',
        4: '1rem',
      },
      margin: {
        0.5: '0.125rem',
        0.75: '0.1875rem',
        1.5: '0.375rem',
        9: '2.25rem',
        '-container-padding': '-15px',
        '0.75em': '0.75em',
        15: '3.75rem',
        '-3px': '-3px',
      },
      maxHeight: {
        80: '20rem',
      },
      outline: {
        solid: ['1px solid #4467ab'],
      },
      padding: {
        9: '2.25rem',
      },
      width: {
        0.5: '0.125rem',
        1.5: '0.375rem',
        100: '25rem',
        '9/10': '90%',
      },

      zIndex: {
        dropdown: '103',
        drawer: '104',
        appbar: '105',
        modal: '107',
      },
    },
  },
  variants: {
    borderColor: ['responsive', 'hover', 'focus', 'focus-within'],
    boxShadow: ['responsive', 'hover', 'focus', 'focus-within'],
  },
  corePlugins: {
    container: false,
  },
  plugins: [],
  future: {
    removeDeprecatedGapUtilities: true,
    purgeLayersByDefault: true,
  },
};
